var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"2149d203b26dc81c2db955bee2788af702aa39df"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

const ENVIRONMENT =
  process.env.ENVIRONMENT || process.env.NODE_ENV || 'development';

// This file is required by @sentry/nextjs for client-side (browser) initialization.
// It initializes Sentry for all client-side code running in the browser.
if (process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: ENVIRONMENT,

    // Capture 10% of transactions in production, 100% elsewhere.
    tracesSampleRate: ENVIRONMENT === 'production' ? 0.1 : 1.0,

    // Set `tracePropagationTargets` to control what URLs distributed tracing should be enabled for
    tracePropagationTargets: [
      'localhost',
      /^\//,
      // Add your production domain here
      /^https:\/\/yourserver\.io\/api/,
    ],

    // Capture Replay for 10% of all sessions,
    // plus 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Ignore specific errors
    ignoreErrors: [
      // Browser extensions
      'top.GLOBALS',
      'chrome-extension://',
      'moz-extension://',

      // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',

      // Rate limit errors - not actionable
      'Too many requests',

      // Network errors - not actionable
      'NetworkError',
      'Network error',
    ],
  });
}

